import React, { useState, useEffect } from 'react';
import { getAllBranches } from '../api/Api';
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';

const BranchSelectionModal = ({ onSelectBranch }) => {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBranch, setSelectedBranch] = useState(null);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await getAllBranches();
        if (response.success) {
          setBranches(response.data);
          console.log("Fetched branches:", response.data); // Debugging line
        } else {
          toast.error("Failed to fetch branches.");
        }
      } catch (error) {
        console.error("Error fetching branches:", error);
        toast.error("Error fetching branches.");
      } finally {
        setLoading(false);
      }
    };
    fetchBranches();
  }, []);

  const handleConfirm = () => {
    if (selectedBranch) {
      onSelectBranch(selectedBranch);
    } else {
      toast.error("Please select a branch.");
    }
  };

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <Loader />
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full">
        <h2 className="text-xl font-bold mb-4 text-gray-800">Select Your Branch</h2>
        {branches.length === 0 ? (
          <p className="text-gray-600">No branches available. Please try again later.</p>
        ) : (
          <div className="space-y-3">
            {branches.map((branch) => (
              <label key={branch._id} className="flex items-center p-3 border border-gray-300 rounded-md cursor-pointer hover:bg-gray-50">
                <input
                  type="radio"
                  name="branch"
                  value={branch._id}
                  checked={selectedBranch === branch._id}
                  onChange={() => setSelectedBranch(branch._id)}
                  className="form-radio h-4 w-4 text-[#16bab1] transition duration-150 ease-in-out"
                />
                <span className="ml-3 text-sm font-medium text-gray-700">{branch.name}</span>
              </label>
            ))}
          </div>
        )}
        <button
          onClick={handleConfirm}
          disabled={!selectedBranch || branches.length === 0}
          className="mt-6 w-full py-3 bg-[#16bab1] text-white font-bold rounded-md hover:bg-[#129a93] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Confirm Selection
        </button>
      </div>
    </div>
  );
};

export default BranchSelectionModal;
